import { AritoHeaderTabs, TabItem } from '@/components/custom/erp';
import { FormFieldActions, FormFieldState } from '../../../hooks';
import type { PhieuThuFormInitialData } from '../../../types';
import InfoDropdown from '../InfoDropdown';
import { FormMode } from '@/types/form';
import { InfoTab } from './InfoTab';

interface BasicInfoTabProps {
  formMode: FormMode;
  initialData?: PhieuThuFormInitialData;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export const BasicInfoTab = ({ formMode, formState, initialData }: BasicInfoTabProps) => {
  const tabs: TabItem[] = [
    {
      id: 'info',
      label: 'Thông tin',
      component: <InfoTab formMode={formMode} formState={formState} />
    }
  ];

  return (
    <AritoHeaderTabs
      tabs={tabs}
      actionButtons={
        formMode !== 'add' &&
        initialData?.uuid && <InfoDropdown uuid={initialData.uuid} ma_ct={initialData?.chung_tu} />
      }
    />
  );
};
